const generate = require('nanoid/generate');

module.exports = function(length) {
  return generate('1234567890abcdefghijklmnopqrstuvwxyz', length);
};
